export default "__VITE_ASSET__DBcxDT01__"